<span class="icon fab fa-pinterest fa-lg" (click)="share()"></span>
